export default class NewsCarousel {
    constructor($el) {
        this.$el = $el;
        this.$scroller = $el.querySelector('[data-news-carousel-scroller]');
        this.$cards = Array.from($el.querySelectorAll('[data-news-carousel-card]'));
        this.$cards.forEach(($card, index) => {
            $card.dataset.newsCarouselIndex = index;
        });
        this.$previous = $el.querySelector('[data-news-carousel-previous]');
        this.$next = $el.querySelector('[data-news-carousel-next]');
        this.isLooping = $el.hasAttribute('data-news-carousel-loop');
        this.activeIndex = 0;
        this.frame = null;
        this.hasReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.previous = this.previous.bind(this);
        this.next = this.next.bind(this);
        this.queueUpdate = this.queueUpdate.bind(this);
        this.update = this.update.bind(this);

        if (! this.$scroller || this.$cards.length < 2 || ! this.$previous || ! this.$next) {
            return;
        }

        if (this.isLooping) {
            this.setupLoop();
            this.scrollToCard(0, 'auto');
        }

        this.bind();
        this.update();
    }

    bind() {
        this.$previous.addEventListener('click', this.previous);
        this.$next.addEventListener('click', this.next);
        this.$scroller.addEventListener('scroll', this.queueUpdate, {passive: true});
        window.addEventListener('resize', this.queueUpdate);
    }

    previous(event) {
        event.preventDefault();
        this.scrollToCard(this.activeIndex - 1);
    }

    next(event) {
        event.preventDefault();
        this.scrollToCard(this.activeIndex + 1);
    }

    queueUpdate() {
        if (this.frame) {
            return;
        }

        this.frame = window.requestAnimationFrame(this.update);
    }

    update() {
        const scrollerRect = this.$scroller.getBoundingClientRect();
        const scrollerCenter = scrollerRect.left + scrollerRect.width / 2;
        let closestDistance = Infinity;
        let $activeCard = this.$cards[0];

        this.$cards.forEach($card => {
            const cardRect = $card.getBoundingClientRect();
            const cardCenter = cardRect.left + cardRect.width / 2;
            const distance = Math.abs(scrollerCenter - cardCenter);

            if (distance < closestDistance) {
                closestDistance = distance;
                $activeCard = $card;
            }
        });

        this.activeIndex = Number($activeCard.dataset.newsCarouselIndex);

        if (this.isLooping && $activeCard.dataset.newsCarouselClone && closestDistance < 2) {
            this.scrollToCard(this.activeIndex, 'auto');
        }

        this.frame = null;
    }

    scrollToCard(index, behavior = null) {
        const targetIndex = this.normalizeIndex(index);
        let $card = this.$originalCards ? this.$originalCards[targetIndex] : this.$cards[targetIndex];

        if (this.isLooping && index < 0) {
            $card = this.$previousClone;
        } else if (this.isLooping && index >= this.$originalCards.length) {
            $card = this.$nextClone;
        }

        if (! $card) {
            return;
        }

        const left = $card.offsetLeft - (this.$scroller.clientWidth - $card.offsetWidth) / 2;

        this.activeIndex = targetIndex;
        this.$scroller.scrollTo({
            left,
            behavior: behavior || (this.hasReducedMotion ? 'auto' : 'smooth'),
        });
    }

    setupLoop() {
        this.$originalCards = this.$cards;
        this.$previousClone = this.$originalCards[this.$originalCards.length - 1].cloneNode(true);
        this.$nextClone = this.$originalCards[0].cloneNode(true);

        this.prepareClone(this.$previousClone);
        this.prepareClone(this.$nextClone);
        this.$scroller.prepend(this.$previousClone);
        this.$scroller.append(this.$nextClone);
        this.$cards = Array.from(this.$scroller.querySelectorAll('[data-news-carousel-card]'));
    }

    prepareClone($card) {
        $card.dataset.newsCarouselClone = 'true';
        $card.setAttribute('aria-hidden', 'true');
        $card.setAttribute('tabindex', '-1');
    }

    normalizeIndex(index) {
        const numberOfCards = this.$originalCards ? this.$originalCards.length : this.$cards.length;

        if (index < 0) {
            return numberOfCards - 1;
        }

        if (index >= numberOfCards) {
            return 0;
        }

        return index;
    }
}
